import React, { useMemo } from 'react';

import { Image } from 'antd';

import DraggableArchiveImage from '@components/PlaylistEditor/DraggableArchiveImage';

import { usePlaylistEditor } from './PlaylistEditorContext';
import { getPlaceholderPictureForBook } from './PlaylistEditorUtils';

const PicturesArchiveList = () => {
    const { mediaTypeToDisplay, isFetchingDocuments, hideUsedPictures, documentsList, playlistItems, singlePage } =
        usePlaylistEditor();

    const isInPlaylist = (document) => {
        return playlistItems.some((item) => item.ID === document.ID);
    };

    const filteredDocumentsList = useMemo(() => {
        const noEncodingDocuments = documentsList.filter((document) => document.Standard && document.Standard.Url);
        if (hideUsedPictures) {
            return noEncodingDocuments.filter((document) => !isInPlaylist(document));
        }
        return noEncodingDocuments;
    }, [documentsList, hideUsedPictures]);

    if (isFetchingDocuments) {
        return <div>Loading...</div>;
    }

    return (
        <div className="pictures-archive-list">
            {mediaTypeToDisplay === 'Photo' ? (
                <>
                    {!singlePage && <DraggableArchiveImage key={0} document={null} isInPlaylist={false} />}
                    <Image.PreviewGroup>
                        {filteredDocumentsList.map((document) => (
                            <DraggableArchiveImage
                                key={document.ID}
                                document={document}
                                isInPlaylist={isInPlaylist(document)}
                            />
                        ))}
                    </Image.PreviewGroup>
                </>
            ) : (
                filteredDocumentsList.map((document) => (
                    <DraggableArchiveImage
                        key={document.ID}
                        document={document}
                        isInPlaylist={isInPlaylist(document)}
                    />
                ))
            )}
        </div>
    );
};

export default PicturesArchiveList;
